import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatTokenDate } from "@helpers/date";
import type { McpConnectionRow } from "../mcpConnectionsViewConfig";

export const ConnectionDateCell = memo(
    ({
        getValue,
    }: CellContext<
        ViewTableFeatures,
        McpConnectionRow,
        string | Date | null
    >) => <ViewTableCell>{formatTokenDate(getValue())}</ViewTableCell>,
);
